module.exports = __webpack_public_path__ + "img/f-es.303c8c2a.png";